module.exports = __webpack_public_path__ + "static/img/realease-thumb.5214dab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/realease-thumb.jpg
// module id = 40
// module chunks = 0